import { z } from "zod";
import { Phase1CheckResultV1Schema } from "./phase1-check-result.js";
export const DEMO_QUALITY_CHECK_ID = "surface-quality.demo-quality";
export const DemoQualityCheckResultV1Schema = Phase1CheckResultV1Schema.extend({
    checkId: z.literal(DEMO_QUALITY_CHECK_ID),
});
export const DemoQualityEvaluatorInputSchema = z
    .object({
    html: z.string(),
    businessName: z.string().optional(),
    industryLabel: z.string().optional(),
})
    .strict();
//# sourceMappingURL=demo-quality-check-result.js.map